import React, { useState } from "react"
import { DialogSaurus } from "../dialog-saurus/dialog-saurus"
import { useThemeQueries } from "theme/util-styles"
import { EnumDialogs, useDialogStore } from "services/store/dialog-store"
import { Box, Button, Grid } from "@material-ui/core"
import { TokenGestaoEmpresaModel } from "api/touchone/models/token-gestao-empresa"
import { CircularLoading } from "components/utils/circular-loading"
import { CardEmpresa } from "components/cards/card-empresa/card-empresa"
import { useNotificacoes } from "components/notificacoes"

export const DialogSelecionarEmpresa = () => {
    const { isMobile } = useThemeQueries()
    const { openCloseDialog, dialogs } = useDialogStore()
    const aberto = dialogs[EnumDialogs.SelecionarEmpresa].aberto
    const [carregando, setCarregando] = useState<boolean>(false)
    const [empresaIdSelecionada, setEmpresaIdSelecionada] = useState<string>('')
    const { showErrorMessage } = useNotificacoes()
    const { empresas, handleSelecionarEmpresa } = dialogs[EnumDialogs.SelecionarEmpresa].props as {
        empresas: TokenGestaoEmpresaModel[]
        handleSelecionarEmpresa: (id: string) => Promise<void>
    }

    const onClickCard = (id: string) => {
        setEmpresaIdSelecionada(id)
    }

    const onClickSelecionarEmpresa = async () => {
        try {
            setCarregando(true)
            if (empresaIdSelecionada !== '') {
                await handleSelecionarEmpresa(empresaIdSelecionada)
            }
        } catch (err: any) {
            showErrorMessage(err.message)
        } finally {
            setCarregando(false)
        }
    }

    return (
        <DialogSaurus
            aberto={aberto}
            titulo='Selecione uma empresa'
            isButtonTitleClose
            tamanho="sm"
            fullScreen={isMobile}
            handleClickClose={() => openCloseDialog(EnumDialogs.SelecionarEmpresa, false)}
            bottomArea={(
                <Box p={2} gridGap={8} display="flex" flexDirection="column">
                    <Button
                        fullWidth
                        disabled={empresaIdSelecionada === ''}
                        onClick={onClickSelecionarEmpresa}
                        color="primary"
                        size="large"
                        variant="contained"
                    >
                        Confirmar
                    </Button>
                </Box>
            )}
        >
            {carregando && <CircularLoading tipo="FULLSIZED" />}
            <Box p={2} width="100%" height="100%">
                <Grid container spacing={2}>
                    {empresas?.map((empresa) => (
                        <Grid item xs={12} key={empresa.Id}>
                            <CardEmpresa model={empresa} selecionado={empresaIdSelecionada === empresa.Id} onClick={onClickCard} />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </DialogSaurus >
    )
}